import { connect } from 'react-redux';
//
import VisualContainer from 'components/visuals/container/container';
import {
  ISummaryProduct,
  EEvaluationUnit,
  ECostFormulaParamTypeLabel,
  EForecastEvaluationTypeLabel,
} from 'store/deal-evaluation/types';
import { IStoreState } from 'store';
import { calculateStartAndEndValues } from 'lib/helpers/date-range';
import { EView } from 'components/deal-results/product-items';
import labels from 'constants/labels';

export interface IVisualContainerStateProps {
  selectedUnitType: EEvaluationUnit;
  selectedForecastLabel: string;
  selectedCostFormulaLabel: string;
  periodStart?: Date | null;
  periodEnd?: Date | null;
  dealName: string;
  pricePerUnitLabel: string;
}

export interface IVisualContainerOwnProps {
  view: EView;
  productSummary: ISummaryProduct;
  productItemId: string;
}

export type TVisualContainerProps = IVisualContainerStateProps & IVisualContainerOwnProps;

const mapStateToProps = ({ dealEvaluation, dealEdit }: IStoreState) => {
  const { products: dealEditProducts, name } = dealEdit;
  const { selectedUnitType, selectedCostFormulaType, selectedForecastType } = dealEvaluation;
  const dateRanges = calculateStartAndEndValues(dealEditProducts);

  const stateForProps: IVisualContainerStateProps = {
    periodStart: dateRanges ? dateRanges.start : null,
    periodEnd: dateRanges ? dateRanges.end : null,
    selectedUnitType,
    selectedForecastLabel: EForecastEvaluationTypeLabel[selectedForecastType],
    selectedCostFormulaLabel: ECostFormulaParamTypeLabel[selectedCostFormulaType],
    dealName: name,
    pricePerUnitLabel:
      selectedUnitType === EEvaluationUnit.TON ? labels.currency.dollarsPerTon : labels.currency.centsPerPound,
  };

  return stateForProps;
};

export default connect(mapStateToProps)(VisualContainer);
